import React, { useState } from 'react';
import WebEnquiries from './WebEnquiries';
import TabView from '../../components/TabView';
import AppEnquiries from './AppEnquiries';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Breadcrumbs from '../../components/BreadCrumbs';
import FpoEnquiries from './FpoEnquiries';
import OldEnquiries from './OldEnquiries';

const Enquiries = () => {
    const [activeTab, setActiveTab] = useState("Web");

    const handleTabChange = (value) => {
        setActiveTab(value);
    };
    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Enquiries' },
            { name: activeTab + " Enquiries" },
        ]} />
        <div className="py-2">
            <StyledHeadingText text={"Enquiries"} />
        </div>
        <TabView
            onChanged={(val) => handleTabChange(val)}
            isCenterAligned={false}
            tabs={[
                {
                    key: 'Web',
                    title: 'Web',
                    content: (<WebEnquiries />),
                },
                {
                    key: 'App',
                    title: 'App',
                    content: (<AppEnquiries />),
                },
                {
                    key: 'Old Mobile',
                    title: 'Old Mobile',
                    content: (<OldEnquiries />),
                },
            ]} />
    </>
    );
};
export default Enquiries;